// Qualifiche (tipo di mansione) e Ruoli (livello gerarchico) degli operatori.
export const QUALIFICHE = ["OSS", "OSA", "EDUCATORE", "CUCINA", "PULIZIE", "MANUTENZIONE", "INFERMIERE", "MEDICO", "ALTRO"];
export const RUOLI_OP = ["SuperAdmin", "Amministratore", "Direttore", "Responsabile", "Coordinatore", "Preposto", "Altro"];
